import { getEnv, getRoot, types } from 'mobx-state-tree';
import { IPhotosiSdk } from '@photosi/expo-photosi-sdk/build/PhotosiSdk';
import { NativeEventEmitter, NativeEventSubscription } from 'react-native';
import { IRootStore } from 'src/store/store';

export const BaseListenersModel = types
  .model({})
  .volatile<{
    listeners: NativeEventSubscription[];
  }>(self => ({
    listeners: [],
  }))
  .views(self => ({
    get root(): IRootStore {
      return getRoot<IRootStore>(self);
    },
    get sdk(): IPhotosiSdk {
      return getEnv(self).sdk;
    },
    get deviceInfo() {
      return getEnv(self).deviceInfo;
    },
  }))
  .actions(self => ({
    emitDebugEvent(eventName: string, data: any) {
      const emitter: NativeEventEmitter = self.sdk.getEventEmitter();
      emitter.emit(eventName, data);
    },

    addListener(subscriptionName: string, subscriptionCallback: (event: any) => void) {
      const emitter: NativeEventEmitter = self.sdk.getEventEmitter();
      const subscription: NativeEventSubscription = emitter.addListener(subscriptionName, subscriptionCallback);
      self.listeners.push(subscription);
    },

    beforeDetach() {
      for (const listener of self.listeners) {
        listener.remove();
      }
      self.listeners = [];
    },
  }));
